/**
 * Mock Registry
 * Carga e indexa los ficheros .json de mocks organizados en subcarpetas por servicio:
 * - mocks/auth/
 * - mocks/clubs/
 * - mocks/competition/
 * - mocks/market/
 * - mocks/squad/
 * - mocks/stadium-economy/
 * - mocks/leagues/
 */
import authLogin from '../../../mocks/auth/login.json';
import authLogout from '../../../mocks/auth/logout.json';
import authUsersMe from '../../../mocks/auth/users-me.json';
import authRefresh from '../../../mocks/auth/refresh.json';

import clubsList from '../../../mocks/clubs/clubs-list.json';
import clubsCreate from '../../../mocks/clubs/create-club.json';
import clubSquad from '../../../mocks/clubs/club-squad.json';
import clubStadium from '../../../mocks/clubs/club-stadium.json';
import clubStaff from '../../../mocks/clubs/club-staff.json';
import clubBalance from '../../../mocks/clubs/club-economy-balance.json';
import clubLedger from '../../../mocks/clubs/club-economy-ledger.json';
import clubShield from '../../../mocks/clubs/club-shield.json';

import competitionMe from '../../../mocks/competition/me-competitions.json';
import competitionStructure from '../../../mocks/competition/competition-structure.json';
import competitionStandings from '../../../mocks/competition/standings.json';
import competitionCalendar from '../../../mocks/competition/calendar.json';
import competitionSimulate from '../../../mocks/competition/simulate-matchday.json';
import competitionAdvance from '../../../mocks/competition/advance-matchday.json';
import competitionPublishRatings from '../../../mocks/competition/publish-editorial-ratings.json';
import competitionMatchLive from '../../../mocks/competition/match-live.json';
import competitionNextMatch from '../../../mocks/competition/next-match.json';

import marketCurrentListings from '../../../mocks/market/current-listings.json';
import marketActiveOffers from '../../../mocks/market/active-offers.json';
import marketSubmitOffer from '../../../mocks/market/submit-offer.json';
import marketUpdateOffer from '../../../mocks/market/update-offer.json';
import marketCancelOffer from '../../../mocks/market/cancel-offer.json';
import marketBuyoutClause from '../../../mocks/market/buyout-clause.json';
import marketFreeAgents from '../../../mocks/market/free-agents.json';
import marketTransferStatus from '../../../mocks/market/transfer-status.json';
import marketOffersHistory from '../../../mocks/market/offers-history.json';
import marketPortfolio from '../../../mocks/market/portfolio.json';

import squadGetLineup from '../../../mocks/squad/get-lineup.json';
import squadSaveLineup from '../../../mocks/squad/save-lineup.json';
import squadAutoPick from '../../../mocks/squad/auto-pick.json';
import squadFormations from '../../../mocks/squad/formations.json';

import stadiumTickets from '../../../mocks/stadium-economy/update-tickets.json';
import stadiumCapacity from '../../../mocks/stadium-economy/upgrade-capacity.json';
import stadiumModule from '../../../mocks/stadium-economy/upgrade-module.json';
import stadiumStaff from '../../../mocks/stadium-economy/upgrade-staff.json';
import stadiumLoan from '../../../mocks/stadium-economy/request-loan.json';
import stadiumSubscription from '../../../mocks/stadium-economy/pay-subscription.json';
import stadiumUpgradesCatalog from '../../../mocks/stadium-economy/upgrades-catalog.json';
import stadiumUpgradesConstruction from '../../../mocks/stadium-economy/upgrades-construction.json';
import stadiumUpgradesQuote from '../../../mocks/stadium-economy/upgrades-quote.json';
import stadiumUpgradesOperation from '../../../mocks/stadium-economy/upgrades-operation.json';
import loansOffer from '../../../mocks/stadium-economy/loans-offer.json';
import loansHistory from '../../../mocks/stadium-economy/loans-history.json';
import loansDebt from '../../../mocks/stadium-economy/loans-debt.json';
import economicSummary from '../../../mocks/stadium-economy/economic-summary.json';

import leaguesList from '../../../mocks/leagues/leagues-list.json';
import leagueDetail from '../../../mocks/leagues/league-detail.json';
import leagueSelect from '../../../mocks/leagues/league-select.json';

import newsList from '../../../mocks/news/news-list.json';

import coachesMarket from '../../../mocks/coaches/market.json';
import coachesContracts from '../../../mocks/coaches/contracts.json';
import coachesOffers from '../../../mocks/coaches/offers.json';
import coachesSubmitOffer from '../../../mocks/coaches/submit-offer.json';
import coachesCancelOffer from '../../../mocks/coaches/cancel-offer.json';

export const MOCK_REGISTRY: Record<string, Record<string, any>> = {
  auth: {
    login: authLogin,
    logout: authLogout,
    'users-me': authUsersMe,
    refresh: authRefresh,
  },
  clubs: {
    'clubs-list': clubsList,
    'create-club': clubsCreate,
    'club-squad': clubSquad,
    'club-stadium': clubStadium,
    'club-staff': clubStaff,
    'club-economy-balance': clubBalance,
    'club-economy-ledger': clubLedger,
    'club-shield': clubShield,
  },
  competition: {
    'me-competitions': competitionMe,
    'competition-structure': competitionStructure,
    standings: competitionStandings,
    calendar: competitionCalendar,
    'simulate-matchday': competitionSimulate,
    'advance-matchday': competitionAdvance,
    'publish-editorial-ratings': competitionPublishRatings,
    'match-live': competitionMatchLive,
    'next-match': competitionNextMatch,
  },
  market: {
    'current-listings': marketCurrentListings,
    'active-offers': marketActiveOffers,
    'submit-offer': marketSubmitOffer,
    'update-offer': marketUpdateOffer,
    'cancel-offer': marketCancelOffer,
    'buyout-clause': marketBuyoutClause,
    'free-agents': marketFreeAgents,
    'transfer-status': marketTransferStatus,
    'offers-history': marketOffersHistory,
    portfolio: marketPortfolio,
  },
  squad: {
    'get-lineup': squadGetLineup,
    'save-lineup': squadSaveLineup,
    'auto-pick': squadAutoPick,
    formations: squadFormations,
  },
  'stadium-economy': {
    'update-tickets': stadiumTickets,
    'upgrade-capacity': stadiumCapacity,
    'upgrade-module': stadiumModule,
    'upgrade-staff': stadiumStaff,
    'request-loan': stadiumLoan,
    'pay-subscription': stadiumSubscription,
    'upgrades-catalog': stadiumUpgradesCatalog,
    'upgrades-construction': stadiumUpgradesConstruction,
    'upgrades-quote': stadiumUpgradesQuote,
    'upgrades-operation': stadiumUpgradesOperation,
    'loans-offer': loansOffer,
    'loans-history': loansHistory,
    'loans-debt': loansDebt,
    'economic-summary': economicSummary,
  },
  leagues: {
    'leagues-list': leaguesList,
    'league-detail': leagueDetail,
    'league-select': leagueSelect,
  },
  news: {
    'news-list': newsList,
  },
  coaches: {
    market: coachesMarket,
    contracts: coachesContracts,
    offers: coachesOffers,
    'submit-offer': coachesSubmitOffer,
    'cancel-offer': coachesCancelOffer,
  },
};

/**
 * Obtiene una copia profunda del mock JSON correspondiente al servicio y nombre.
 * Intenta primero cargar el fichero .json estático vía HTTP (fetch('/mocks/...')),
 * y si no está disponible o falla, utiliza la copia importada del fichero .json.
 */
export async function getMockJson<T = any>(
  service: string,
  mockName: string
): Promise<T> {
  const jsonPath = `/mocks/${service}/${mockName}.json`;
  if (typeof fetch !== 'undefined') {
    try {
      const res = await fetch(jsonPath, {
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        const data = await res.json();
        return JSON.parse(JSON.stringify(data)) as T;
      }
    } catch {
      // fallback a registry local de ficheros .json
    }
  }

  const serviceMocks = MOCK_REGISTRY[service];
  if (!serviceMocks || !serviceMocks[mockName]) {
    console.warn(`Mock no encontrado en registro: ${service}/${mockName}.json`);
    return {} as T;
  }
  return JSON.parse(JSON.stringify(serviceMocks[mockName])) as T;
}
